module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (showCloseButton) { ;
__p += '\n<span class="close-icon"></span>\n';
 } ;
__p += '\n\n<a class="next-notification" title="Click for next notification..."></a>\n\n<div class="content">\n    <i class="glyphicon glyphicon-exclamation-sign important"></i>\n    <span class="message"></span>\n\n    ';
 if (action.indexOf("duplicate") !== -1) { ;
__p += '\n        <span class="duplicate"><a class="action">Make a copy</a> - will not affect this Experience.</span>\n    ';
 } ;
__p += '\n    ';
 if (action.indexOf("reload") !== -1) { ;
__p += '\n        <span class="reload"><a class="action">Refresh</a>';
 if (request !== "fetch" && request !== "destroy") {;
__p += ' - your changes will be lost.';
 } ;
__p += '</span>\n    ';
 } ;
__p += '\n    ';
 if (action.indexOf("retry") !== -1) { ;
__p += '\n        <span class="retry"><a class="action">Try again</a></span>\n    ';
 } ;
__p += '\n    ';
 if (action.indexOf("relogin") !== -1) { ;
__p += '\n        <span class="relogin"><a class="action">Refresh Sign In</a></span>\n    ';
 } ;
__p += '\n    ';
 if (action.indexOf("community") !== -1) { ;
__p += '\n        <span class="community"><a class="action">Visit the Community</a></span>\n    ';
 } ;
__p += '\n    ';
 if (action.indexOf("removeIncompatibleWidgets") !== -1) { ;
__p += '\n        <span class="removeIncompatibleWidgets"><a class="action">Click Here</a> to delete all ineligible widgets from your experience. </span>\n    ';
 } ;
__p += '\n\n</div>\n<div class="remove-incompatible-widgets-region"></div>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/notificationbar/NotificationBar.tpl
// module id = 1777
// module chunks = 0